/* eslint-disable react/no-danger-with-children */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useMemo, Suspense, lazy, useState, useRef } from 'react';
import fetchAPI from '../helper/axios';
import Load from './load';
import PureCounter from '@srexi/purecounterjs';
import fetchAPICustom from '../helper/custom';
import TestimonalSliderClient from './testimonialsilderclient';
import { ImagePath } from '../helper/constants';
import CountUp from 'react-countup';
import { useGroOneAppData } from '../hooks/useGroOneAppData';
// Import optimized components
import GroOneHero from '../components/grooneapp/GroOneHero';
import LazySection from '../components/about/LazySection';
import GroOneFAQ from '../components/grooneapp/GroOneFAQ';
import GroOneDownload from '../components/grooneapp/GroOneDownload';
import GroOneCarousel from '../components/grooneapp/GroOneCarousel';

export interface AccordionItem {
  entity_id: string;
  ac_title: string;
  ac_desc?: string;
}

export interface FAQData {
  id: string;
  title: string;
  description: string;
  accordion: AccordionItem[];
}
export interface GroOneSlider {
  id: string;
  title: string;
  description: string;
  slider_images: any[];
}
const Grooneapp: React.FC = () => {
 

    const [groData1, setData1] = useState<any>(null);
    const [groImg3, setGroImgData3] = useState<any>();

    const [groData2, setData2] = useState<any>(null);
 
    const [groMainWSlider, setDataWMain] = useState<any>([]);
    const [groMainMSlider, setDataMMain] = useState<any>([]);
    const [grokavachSlider, setDatakavach] = useState<any>([]);
    const [groFASTagSlider, setDataFASTag] = useState<any>([]);
    const [groDhanSlider, setDataDhan] = useState<any>([]);
    const [groFleetSlider, setDataFleet] = useState<any>([]);
    const [groMarketPlace, setDataMarket] = useState<any>([]);
    const [groChartbot, setDataAIChart] = useState<any>([]);
    let [GooglePlayurl, setImageUrl1] = useState('');
       let [AppStoreurl, setImageUrl2] = useState('');
    const [footerData, setDataurl] = useState<any>(null);
    const [loading1, setLoading] = useState<boolean>(true);
    const [error1, setError] = useState<string | null>(null);
const imagePath=ImagePath;

  // Focusable carousel reference
  const carouselRef = useRef<HTMLDivElement>(null);
    
  const [retry, setRetry] = useState(0); // for retry trigger
const { data, loading, error } = useGroOneAppData();

useEffect(() => {
    const loadData = async () => {
      try {
        setData1(await fetchAPI('node/27'));
        setGroImgData3(await fetchAPI('media/34/edit'));
        
        setData2(await fetchAPI('node/28'));
      

        // main sider gro one app
        setDataWMain(await fetchAPICustom('webslider.php?id=12')); 
        setDataMMain(await fetchAPICustom('webslider.php?id=8')); 
        setDatakavach(await fetchAPICustom('webslider.php?id=7')); 
        setDataFASTag(await fetchAPICustom('webslider.php?id=9')); 
        setDataDhan(await fetchAPICustom('webslider.php?id=10')); 
        setDataFleet(await fetchAPICustom('webslider.php?id=11'));
        setDataMarket(await fetchAPICustom('webslider.php?id=13')); 
        setDataAIChart(await fetchAPICustom('webslider.php?id=14')); 

      
        
        
        setDataurl(await fetchAPI('node/31'));

      
      } catch (err: any) {

        setError(err.message);

         // Retry after 3 seconds
        setTimeout(() => setRetry((prev) => prev + 1), 10000);
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, [retry]);
  
    const [currentIndex, setCurrentIndex] = useState(0);
     const [currentIndexsub, setCurrentIndexsub] = useState(0);
   
    const nextSlide = () => {
      setCurrentIndex((prev) => (prev + 1) % groMainWSlider?.data.slider_images.length);
    };
    const prevSlide = () => {
      setCurrentIndex((prev) => (prev - 1 + groMainWSlider?.data.slider_images.length) % groMainWSlider?.data.slider_images.length);
    };
    const nextSlide1 = () => {
      setCurrentIndexsub((prev) => (prev + 1) % grokavachSlider?.data.slider_images.length);
    };
    const prevSlide1 = () => {
      setCurrentIndexsub((prev) => (prev - 1 + grokavachSlider?.data.slider_images.length) % grokavachSlider?.data.slider_images.length);
    };
      const nextSlide2 = () => {
      setCurrentIndexsub((prev) => (prev + 1) % groFASTagSlider?.data.slider_images.length);
    };
    const prevSlide2 = () => {
      setCurrentIndexsub((prev) => (prev - 1 + groFASTagSlider?.data.slider_images.length) % groFASTagSlider?.data.slider_images.length);
    };
      const nextSlide3 = () => {
      setCurrentIndexsub((prev) => (prev + 1) % groDhanSlider?.data.slider_images.length);
    };
    const prevSlide3 = () => {
      setCurrentIndexsub((prev) => (prev - 1 + groDhanSlider?.data.slider_images.length) % groDhanSlider?.data.slider_images.length);
    };
      const nextSlide4 = () => {
      setCurrentIndexsub((prev) => (prev + 1) % groFleetSlider?.data.slider_images.length);
    };
    const prevSlide4 = () => {
      setCurrentIndexsub((prev) => (prev - 1 + groFleetSlider?.data.slider_images.length) % groFleetSlider?.data.slider_images.length);
    };
    const nextSlide5 = () => {
      setCurrentIndexsub((prev) => (prev + 1) % groMarketPlace?.data.slider_images.length);
    };
    const prevSlide5 = () => {
      setCurrentIndexsub((prev) => (prev - 1 + groMarketPlace?.data.slider_images.length) % groMarketPlace?.data.slider_images.length);
    };
    const nextSlide6 = () => {
      setCurrentIndexsub((prev) => (prev + 1) % groChartbot?.data.slider_images.length);
    };
    const prevSlide6 = () => {
      setCurrentIndexsub((prev) => (prev - 1 + groChartbot?.data.slider_images.length) % groChartbot?.data.slider_images.length);
    };
    // Keyboard navigation
    useEffect(() => {
      const handleKey = (e: KeyboardEvent) => {
        if (carouselRef.current && document.activeElement === carouselRef.current) {
            if (e.key === 'ArrowRight') nextSlide();
            if (e.key === 'ArrowLeft') prevSlide();
            if (e.key === 'ArrowRight') nextSlide1();
            if (e.key === 'ArrowLeft') prevSlide1();
            if (e.key === 'ArrowRight') nextSlide2();
            if (e.key === 'ArrowLeft') prevSlide2();
            if (e.key === 'ArrowRight') nextSlide3();
            if (e.key === 'ArrowLeft') prevSlide3();
            if (e.key === 'ArrowRight') nextSlide4();
            if (e.key === 'ArrowLeft') prevSlide4();
            if (e.key === 'ArrowRight') nextSlide5();
            if (e.key === 'ArrowLeft') prevSlide5();
            if (e.key === 'ArrowRight') nextSlide6();
            if (e.key === 'ArrowLeft') prevSlide6();
        }
      };
      window.addEventListener('keydown', handleKey);
      return () => window.removeEventListener('keydown', handleKey);
    }, []);
 for (let i = 0; i < groMainWSlider?.data?.slider_images.length; i++) { 
    const slideimg = groMainWSlider.data.slider_images[i];
    slideimg.slider_img_url = slideimg.slider_img_url.replace("public://", "");
  }
   for (let i = 0; i < groMainMSlider?.data?.slider_images.length; i++) { 
    const slideimg = groMainMSlider.data.slider_images[i];
    slideimg.slider_img_url = slideimg.slider_img_url.replace("public://", "");
  }
for (let i = 0; i < grokavachSlider?.data?.slider_images.length; i++) { 
    const slideimg = grokavachSlider.data.slider_images[i];
    slideimg.slider_img_url = slideimg.slider_img_url.replace("public://", "");
  }
  for (let i = 0; i < groFASTagSlider?.data?.slider_images.length; i++) { 
    const slideimg = groFASTagSlider.data.slider_images[i];
    slideimg.slider_img_url = slideimg.slider_img_url.replace("public://", "");
  }
  for (let i = 0; i < groDhanSlider?.data?.slider_images.length; i++) { 
    const slideimg = groDhanSlider.data.slider_images[i];
    slideimg.slider_img_url = slideimg.slider_img_url.replace("public://", "");
  }
  for (let i = 0; i < groFleetSlider?.data?.slider_images.length; i++) { 
    const slideimg = groFleetSlider.data.slider_images[i];
    slideimg.slider_img_url = slideimg.slider_img_url.replace("public://", "");
  }
    for (let i = 0; i < groMarketPlace?.data?.slider_images.length; i++) { 
    const slideimg = groMarketPlace.data.slider_images[i];
    slideimg.slider_img_url = slideimg.slider_img_url.replace("public://", "");
  }
 for (let i = 0; i < groChartbot?.data?.slider_images.length; i++) { 
    const slideimg = groChartbot.data.slider_images[i];
    slideimg.slider_img_url = slideimg.slider_img_url.replace("public://", "");
  }

   for (let i = 0; i < footerData?.field_link_url.length; i++) { 
            const url = footerData?.field_link_url[i];
            if(url.title === 'Google Play'){
               GooglePlayurl = url.uri.replace("internal:", "");
            }
             if(url.title === 'App Store'){
               AppStoreurl = url.uri.replace("internal:", "");
            }
          
    }

     // Process footer URLs
      const processedUrls = useMemo(() => {
        if (!data?.footer) return { googlePlayUrl: '', appStoreUrl: '' };
        
        let googlePlayUrl = '';
        let appStoreUrl = '';
        
        if (data.footer.field_link_url) {
          for (const url of data.footer.field_link_url) {
            if (url.title === 'Google Play') {
              googlePlayUrl = url.uri.replace("internal:", "");
            }
            if (url.title === 'App Store') {
              appStoreUrl = url.uri.replace("internal:", "");
            }
          }
        }
        
        return { googlePlayUrl, appStoreUrl };
      }, [data?.footer]);

    const appurl = localStorage.getItem('appurl');
    const appimg = localStorage.getItem('appimg');
    const googleurl = localStorage.getItem('googleurl');
    const googleimg = localStorage.getItem('googleimg');
    const grooneappcontent = localStorage.getItem('grooneappcontent');
   if (loading1) return    <Load />;
//   if (error1) return <div>Error: {error1}</div>;
  // Show loading state
  if (loading) {
    return <Load />;
  }

//   if (error) {
//     return (
//       <div className="error-container">
//         <h2>Something went wrong</h2>
//         <p>{error}</p>
//       </div>
//     );
//   }

  if (!data) {
    return <div>No data available</div>;
  }
  return ( 
       <>
  
        <main className="main">
           {/* Hero Section */}
            {data.hero && (
            <GroOneHero 
                data={data.hero.data}
                images={data.hero.images}
                urls={processedUrls}
                appImages={data.stats.images}
            />
            )}

        {/* About Section */}
        <section id="about" className="about section mt-3">

            <div className="container" data-aos="fade-up" data-aos-delay="100">
                <div className="row gx-2 align-items-xl-start gy-5">

                    <div className="col-xl-8 content mt-4 pe-lg-5">
                        {/*<h3>About Us</h3>*/}
                        <label className="label-title">
                             {groData1?.field_description?.[0]?.value}
                            
                            <span> {groData1?.field_sub_title?.[0]?.value}</span>
                        </label>
                        <p className="py-3" dangerouslySetInnerHTML={{ __html:groData1?.field_content?.[0]?.value }} />
                            
                        <img src="assets/img/gro-one-app-about-mobile.png" className="img-fluid gro-one-app-about-mobile" />
                        <h5>
                          {groData1?.field_sub_title?.[1]?.value}
                        </h5>
                        <div className="row gx-2">
                            <div className="col-md-6">
                                <ul className="list-unstyled">
                                    <li><i className="bi bi-check-circle-fill"></i><span> {groData1?.field_sub_description?.[0]?.value}</span></li>
                                    <li><i className="bi bi-check-circle-fill"></i> <span>{groData1?.field_sub_description?.[1]?.value}</span></li>
                                </ul>
                            </div>
                            <div className="col-md-6">
                                <ul className="list-unstyled">
                                    <li><i className="bi bi-check-circle-fill"></i><span> {groData1?.field_sub_description?.[2]?.value}</span></li>
                                </ul>
                            </div>
                        </div>

                        {/* Stats Section */}
                        <section id="stats" className="stats stats-gro-one section py-lg-2">

                            <div className="container">
                                <div className="row gx-2">
                                    <div className="offset-sm-1 col-sm-10">
                                        <div className="row gy-4" data-aos="fade-up" data-aos-delay="100">

                                            <div className="col-lg-4 col-md-4 col-sm-6 mt-2 d-flex flex-column align-items-center d-none">
                                                <div className="stats-item">
                                                    <CountUp start={0} end={Number(groData2?.field_title?.[0]?.value) || 0} duration={3} />k +
                                                    {/* <span data-purecounter-start="0" data-purecounter-end={groData2?.field_title?.[0]?.value} data-purecounter-duration="1" className="purecounter"></span>k + */}
                                                    <p>{groData2?.field_sub_title?.[0]?.value}  </p>
                                                </div>
                                            </div>{/* End Stats Item */}

                                            <div className="col-lg-6 col-md-6 col-sm-6 mt-2  d-flex flex-column align-items-center">
                                                <div className="stats-item">
                                                       <CountUp start={0} end={Number(groData2?.field_title?.[0]?.value) || 0} duration={3} /> +
                                                    {/* <span data-purecounter-start="0" data-purecounter-end={groData2?.field_title?.[1]?.value} data-purecounter-duration="1" className="purecounter"></span> + */}
                                                     <p>{groData2?.field_sub_title?.[0]?.value}  </p>
                                                </div>
                                            </div>{/* End Stats Item */}

                                            <div className="col-lg-6 col-md-6 col-sm-6 mt-2  d-flex flex-column align-items-center">
                                                <div className="stats-item">
                                                                                                           <CountUp start={0} end={Number(groData2?.field_title?.[1]?.value) || 0} duration={3} />*7
                                                    {/* <span data-purecounter-start="0" data-purecounter-end={groData2?.field_title?.[2]?.value} data-purecounter-duration="1" className="purecounter"></span>*7 */}
                                                     <p>{groData2?.field_sub_title?.[1]?.value}  </p>
                                                </div>
                                            </div>{/* End Stats Item */}



                                        </div>
                                    </div>
                                </div>
                            </div>

                        </section>{/* /Stats Section */}
                    </div>

                    <div className="col-xl-4 gro-one-app-about-big-mobile">
                        <div className="row gy-4  ">
                            <div className="col-sm-12 text-center">
                                <img src={groImg3?.thumbnail?.[0]?.url} className="img-fluid px-5  " />
                            </div>

                        </div>
                    </div>

                </div>
            </div>

        </section>{/* /About Section */}
        {/* Highlighting Features Section */}

        <section id="aboutgro-one-highlight " className="features aboutgro-one-highlight section text-center d-none">
            <div className="container">
                <h2>Highlighting Features</h2>
                <div className="row gy-4 mt-3">

                    <div className="col-lg-3 col-md-4" data-aos="fade-up" data-aos-delay="100">
                        <div className="features-item">
                            <img src="assets/img/grokavach.png" height="40px" />
                            <h3><a href="" className="stretched-link">Gro Kavach <i className="bi bi-chevron-right"></i></a></h3>
                        </div>
                    </div>{/* End Feature Item */}

                    <div className="col-lg-3 col-md-4" data-aos="fade-up" data-aos-delay="200">
                        <div className="features-item">
                            <img src="assets/img/groFasttag.png" height="25px" />
                            <h3><a href="" className="stretched-link">Gro FastTag <i className="bi bi-chevron-right"></i></a></h3>
                        </div>
                    </div>{/* End Feature Item */}

                    <div className="col-lg-3 col-md-4" data-aos="fade-up" data-aos-delay="300">
                        <div className="features-item">
                            <img src="assets/img/en-Dhan.png" height="30px" />
                            <h3><a href="" className="stretched-link">Gro eN-Dhan <i className="bi bi-chevron-right"></i></a></h3>

                        </div>
                    </div>{/* End Feature Item */}

                    <div className="col-lg-3 col-md-4" data-aos="fade-up" data-aos-delay="400">
                        <div className="features-item">

                            <img src="assets/img/groFleetGps.png" height="35px" />
                            <h3><a href="" className="stretched-link">Gro-Fleet GPS <i className="bi bi-chevron-right"></i></a></h3>

                        </div>
                    </div>{/* End Feature Item */}



                </div>

            </div>

        </section>
        {/* /Highlighting Features Section */}
        {/* Example Code Start*/}

        <div id="carouselaboutapp" className="carousel carousel-dark slide pointer-event d-none">

            <ul className="nav justify-content-center slide-nav">
                <li className="nav-item">
                    <button type="button" data-bs-toggle="tab" data-bs-target="#carouselaboutapp" data-bs-slide-to="0" className="nav-link active" aria-current="page" aria-label="Slide 1">Gro Kavach</button>
                </li>
                <li className="nav-item">
                    <button type="button" data-bs-toggle="tab" data-bs-target="#carouselaboutapp" data-bs-slide-to="1" aria-label="Slide 2" className="nav-link">Gro FASTag</button>
                </li>
                <li className="nav-item">
                    <button type="button" data-bs-toggle="tab" data-bs-target="#carouselaboutapp" data-bs-slide-to="2" aria-label="Slide 3" className="nav-link">Gro eN-Dhan</button>
                </li>
                <li className="nav-item">
                    <button type="button" data-bs-toggle="tab" data-bs-target="#carouselaboutapp" data-bs-slide-to="3" aria-label="Slide 4" className="nav-link">Gro Fleet GPS</button>
                </li>
                <li className="nav-item">
                    <button type="button" data-bs-target="#carouselaboutapp" data-bs-slide-to="3" aria-label="Slide 4" className="nav-link">Gro Market Place</button>
                </li>
            </ul>
            <div className="carousel-indicators">
                <button type="button" data-bs-target="#carouselaboutapp" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"> </button>
                <button type="button" data-bs-target="#carouselaboutapp" data-bs-slide-to="1" aria-label="Slide 2"> </button>
                <button type="button" data-bs-target="#carouselaboutapp" data-bs-slide-to="2" aria-label="Slide 3"> </button>
                <button type="button" data-bs-target="#carouselaboutapp" data-bs-slide-to="3" aria-label="Slide 4"> </button>

            </div>
            <div className="carousel-inner">
                <div className="carousel-item active" data-bs-interval="10000">
                    <section id="aboutGrokavach" className="about section mt-0 bg-grey-gradient">

                        <div className="container ">
                            <div className="row gx-2 align-items-xl-start gy-5 flex-lg-row-reverse">


                                <div className="col-xl-6 content mt-4 pe-5 aos-init aos-animate" data-aos="fade-up" data-aos-delay="100">
                                    <h2>Gro Kavach</h2>
                                    <h4>Guards Your Diesel Tank</h4>
                                    <p className="py-3">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
                                    <div className="row gx-2">
                                        <div className="col-sm-11">
                                            <ul className="list-unstyled abt-ico-list">
                                                <li>
                                                    <img src="assets/img/icon/anti-theft.png"/>
                                                    <h6> Anti-theft, Tamper Proof</h6>
                                                    <p>Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam</p>
                                                </li>
                                                <li>
                                                    <img src="assets/img/icon/thumb-up.png" />
                                                    <h6> Reliable &amp; Proven</h6>
                                                    <p>Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim.</p>
                                                </li>
                                                <li>
                                                    <img src="assets/img/icon/install.png" />
                                                    <h6> Easy install</h6>
                                                    <p>Sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa.</p>
                                                </li>
                                                <li>
                                                    <img src="assets/img/icon/roi.png" />
                                                    <h6>ROI In Just 15 Days</h6>
                                                    <p>Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit.</p>
                                                </li>
                                            </ul>
                                        </div>

                                    </div>
                                </div>
                                <div className="col-md-5 d-flex align-items-center aos-init aos-animate" data-aos="zoom-out" data-aos-delay="100">
                                    <div className="row gy-4 ">
                                        <div className="col-sm-12 text-center">
                                            <img src="assets/img/gro-one-kavach.png" className="img-fluid px-lg-5 mb-5" />
                                            {/*  <button type="button" className="btn btn-success">DOWNLOAD NOW</button>*/}
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                    </section>
                </div>
                <div className="carousel-item " data-bs-interval="2000">
                    {/* aboutFASTag Section */}
                    <section id="aboutFASTag" className="about section mt-0 bg-grey-gradient">

                        <div className="container">
                            <div className="row gx-2 align-items-xl-start gy-5">


                                <div className="offset-xl-1 col-xl-6 content mt-4 pe-5" data-aos="fade-up" data-aos-delay="100">
                                    <h2>Gro FASTag</h2>

                                    <h4>FASTag by IDFB First Bank</h4>
                                    <p className="py-3">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>


                                    <div className="row gx-2">
                                        <div className="  col-sm-11">
                                            <ul className="list-unstyled abt-ico-list">
                                                <li>
                                                    <img src="assets/img/icon/toll-payment.png" />
                                                    <h6> Easy Toll Payments</h6>
                                                    <p>Enables digital payments across 15,000+ HPCL fuel stations across the country.</p>
                                                </li>
                                                <li>
                                                    <img src="assets/img/icon/time.png" />
                                                    <h6>
                                                        Saves Time, Reduces Queueing
                                                    </h6>
                                                    <p>First-of-its-kind digital tyre purchase through credit.</p>
                                                </li>
                                                <li>
                                                    <img src="assets/img/icon/link.png" />
                                                    <h6>
                                                        Linked To Gro Account
                                                    </h6>
                                                    <p>Toll credit is  available through a digital channel. Higher cashback than direct purchase for single truck and small fleet owners.</p>
                                                </li>
                                                <li>
                                                    <img src="assets/img/icon/roi.png" />
                                                    <h6>ROI In Just 15 Days</h6>
                                                    <p>Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit.</p>
                                                </li>
                                            </ul>
                                        </div>

                                    </div>


                                </div>
                                <div className="col-md-5 d-flex align-items-center" data-aos="zoom-out" data-aos-delay="100">
                                    <div className="row gy-4  ">
                                        <div className="col-sm-12 text-center">
                                            <img src="assets/img/gro-one-fastTag.png" className="img-fluid px-lg-5 mb-5" />
                                            {/* <button type="button" className="btn btn-success">DOWNLOAD NOW</button>*/}
                                        </div>

                                    </div>
                                </div>

                            </div>
                        </div>

                    </section>{/* /aboutFASTag Section */}

                </div>

                <div className="carousel-item" data-bs-interval="2000">
                    {/* aboutenDhan Section */}
                    <section id="aboutenDhan" className="about section mt-0 bg-grey-gradient">

                        <div className="container" data-aos="fade-up" data-aos-delay="100">
                            <div className="row gx-2 align-items-xl-start gy-5 flex-lg-row-reverse">


                                <div className="col-xl-6 content mt-4 pe-5" data-aos="fade-up" data-aos-delay="100">
                                    <h2>Gro eN-Dhan</h2>

                                    <h4>
                                        Want more earning opportunities to grow your business?
                                    </h4>
                                    <p className="py-3">Gro gives you access to credit services so you can increase your earnings and leverage the benefits of scale. </p>

                                    <h4 className="mb-4"><b> Partner with gro today to enjoy</b></h4>
                                    <div className="row gx-2">
                                        <div className="col-sm-11">
                                            <ul className="list-unstyled abt-ico-list">
                                                <li>
                                                    <img src="assets/img/icon/fuel-credit.png" />
                                                    <h6>
                                                        Fuel Credit
                                                    </h6>
                                                    <p>Enables digital payments across 15,000+ HPCL fuel stations across the country.</p>
                                                </li>
                                                <li>
                                                    <img src="assets/img/icon/tyre-credit.png" />
                                                    <h6>Tyre Credit</h6>
                                                    <p>First-of-its-kind digital tyre purchase through credit.</p>
                                                </li>
                                                <li>
                                                    <img src="assets/img/icon/toll-credit.png" />
                                                    <h6>
                                                        Toll Credit
                                                    </h6>
                                                    <p>Toll credit is  available through a digital channel. Higher cashback than direct purchase for single truck and small fleet owners.</p>
                                                </li>

                                            </ul>
                                        </div>

                                    </div>


                                </div>
                                <div className="col-md-5 d-flex align-items-center" data-aos="zoom-out" data-aos-delay="100">
                                    <div className="row gy-4 ">
                                        <div className="col-sm-12 text-center">
                                            <img src="assets/img/gro-one-enDhan.png" className="img-fluid px-lg-5 mb-5" />
                                            {/*<button type="button" className="btn btn-success">DOWNLOAD NOW</button>*/}
                                        </div>

                                    </div>
                                </div>

                            </div>
                        </div>

                    </section>{/* /aboutenDhan Section */}

                </div>
                <div className="carousel-item">
                    {/* aboutFleetGps Section */}
                    <section id="aboutFleetGps" className="about section mt-0 bg-grey-gradient">

                        <div className="container" data-aos="fade-up" data-aos-delay="100">
                            <div className="row gx-2 align-items-xl-start gy-5">


                                <div className="offset-xl-1 col-xl-6 content mt-4 pe-5" data-aos="fade-up" data-aos-delay="100">
                                    <h2>Gro Fleet GPS</h2>

                                    <h4>Control In Your Palm</h4>
                                    <p className="py-3">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>

                                    <div className="row gx-2">
                                        <div className=" col-sm-11">
                                            <ul className="list-unstyled abt-ico-list">
                                                <li>
                                                    <img src="assets/img/icon/map-pin-track.png" />
                                                    <h6> Real-time Vehicle Tracking</h6>
                                                    <p>Enables digital payments across 15,000+ HPCL fuel stations across the country.</p>
                                                </li>
                                                <li>
                                                    <img src="assets/img/icon/star-rating.png" />
                                                    <h6>
                                                        Driver Behaviour Scoring
                                                    </h6>
                                                    <p>First-of-its-kind digital tyre purchase through credit.</p>
                                                </li>
                                                <li>
                                                    <img src="assets/img/icon/alert.png" />
                                                    <h6>
                                                        Alerts, Reports, Geofencing
                                                    </h6>
                                                    <p>Toll credit is  available through a digital channel. Higher cashback than direct purchase for single truck and small fleet owners.</p>
                                                </li>
                                                <li>
                                                    <img src="assets/img/icon/map-pin.png" />
                                                    <h6>Nearest Service Mandi Outlet Locator</h6>
                                                    <p>Toll credit is  available through a digital channel. Higher cashback than direct purchase for single truck and small fleet owners.</p>
                                                </li>
                                            </ul>
                                        </div>

                                    </div>


                                </div>
                                <div className="col-md-5 d-flex align-items-center" data-aos="zoom-out" data-aos-delay="100">
                                    <div className="row gy-4  ">
                                        <div className="col-sm-12 text-center">
                                            <img src="assets/img/gro-one-fleet-gps.png" className="img-fluid px-lg-5 mb-5" />
                                            {/* <button type="button" className="btn btn-success">DOWNLOAD NOW</button>*/}
                                        </div>

                                    </div>
                                </div>

                            </div>
                        </div>

                    </section>
                    {/* /aboutFASTag Section */}

                </div>
            </div>
            <button className="carousel-control-prev" type="button" data-bs-target="#carouselaboutapp" data-bs-slide="prev">
                <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                <span className="visually-hidden">Previous</span>
            </button>
            <button className="carousel-control-next" type="button" data-bs-target="#carouselaboutapp" data-bs-slide="next">
                <span className="carousel-control-next-icon" aria-hidden="true"></span>
                <span className="visually-hidden">Next</span>
            </button>

        </div>
         <LazySection>
        <div id="carouselaboutapp" className="carousel carousel-dark slide pointer-event">

            <ul className="nav justify-content-center slide-nav">
                  {groMainWSlider?.data?.slider_images?.map((slide:any, idx:number) => (
                <li className="nav-item" key={idx}>
                    <button type="button" data-bs-toggle="tab"  onClick={() => setCurrentIndex(idx)} data-bs-target="#carouselaboutapp" data-bs-slide-to="0" className={`nav-link ${idx === currentIndex ? 'active' : ''}`} aria-current="page" aria-label="Slide 1">{slide.button_title}</button>
                </li>
                 ))}
            </ul>
            <div className="carousel-indicators">
                  {groMainWSlider?.data?.slider_images?.map((slide:any, idx:number) => (
                <button type="button" key={idx} onClick={() => setCurrentIndex(idx)} data-bs-target="#carouselaboutapp" aria-current="true"  className={`${idx === currentIndex ? 'active' : ''}`}    /> 
                  ))}

            </div>
            <div className="carousel-inner">
                {groMainWSlider?.data?.slider_images?.map((slide:any, idx:number) => (
                <div className={`carousel-item ${idx === currentIndex ? 'active' : ''}`}   data-bs-interval={`${idx + 1}000`} key={idx}>
                    <section id="aboutGrokavach" className="about section mt-0 bg-grey-gradient">

                        <div className="container ">
                            <div className="row gx-2 align-items-xl-start gy-5 flex-lg-row-reverse">


                                <div className="col-xl-6 content mt-4 pe-5 aos-init aos-animate" data-aos="fade-up" data-aos-delay="100">
                                    <h2>{slide.button_title}</h2>
                                    <h5 className="py-1 fw-light" dangerouslySetInnerHTML={{ __html:slide.slider_title }} />
                                    {/* <p className="py-3" dangerouslySetInnerHTML={{ __html:slide.slider_desc }} /> */}
                                     <h4 className={`${groMainWSlider?.data?.description ? 'mb-4' : 'd-none'}`} > <b dangerouslySetInnerHTML={{ __html:groDhanSlider?.data?.description  }} /> </h4>
                                    <div className="row gx-2">
                                        <div className="col-sm-11">
                                            <ul className={
                                                    slide.button_title === grokavachSlider?.data?.slidername
                                                    ? "list-unstyled abt-ico-list"
                                                    : "d-none"
                                                }>
                                                 {slide.button_title === grokavachSlider?.data?.slidername ? (
                                                    grokavachSlider?.data?.slider_images?.map((item:any, index:number) => (
                                                        <li key={index}>
                                                            <img src={`${imagePath}${item.slider_img_url}`} />
                                                            <h6 dangerouslySetInnerHTML={{ __html:item.slider_title }} />
                                                            <p dangerouslySetInnerHTML={{ __html:item.slider_desc }} />
                                                        </li>
                                                    ))) : ( <p>No data found.</p> )}
                                                    </ul>
                                                     <ul className={
                                                    slide.button_title === groFASTagSlider?.data?.slidername
                                                    ? "list-unstyled abt-ico-list"
                                                    : "d-none"
                                                }>
                                                    {slide.button_title === groFASTagSlider?.data?.slidername ? (
                                                    groFASTagSlider?.data?.slider_images?.map((item:any, index:number) => (
                                                        <li key={index}>
                                                            <img src={`${imagePath}${item.slider_img_url}`} />
                                                            <h6 dangerouslySetInnerHTML={{ __html:item.slider_title }} />
                                                            <p dangerouslySetInnerHTML={{ __html:item.slider_desc }} />
                                                        </li>
                                                    ))) : ( <p>No data found.</p> )}
                                                     </ul>
                                                     <ul className={
                                                    slide.button_title === groDhanSlider?.data?.slidername
                                                    ? "list-unstyled abt-ico-list"
                                                    : "d-none"
                                                }>
                                                    {slide.button_title === groDhanSlider?.data?.slidername ? (
                                                    groDhanSlider?.data?.slider_images?.map((item:any, index:number) => (
                                                        <li key={index}>
                                                            <img src={`${imagePath}${item.slider_img_url}`} />
                                                            <h6 dangerouslySetInnerHTML={{ __html:item.slider_title }} />
                                                            <p dangerouslySetInnerHTML={{ __html:item.slider_desc }} />
                                                        </li>
                                                    ))) : ( <p>No data found.</p> )}
                                                      </ul>
                                                     <ul className={
                                                    slide.button_title === groFleetSlider?.data?.slidername
                                                    ? "list-unstyled abt-ico-list"
                                                    : "d-none"
                                                }>
                                                    {slide.button_title === groFleetSlider?.data?.slidername ? (
                                                    groFleetSlider?.data?.slider_images?.map((item:any, index:number) => (
                                                        <li key={index}>
                                                            <img src={`${imagePath}${item.slider_img_url}`} />
                                                            <h6 dangerouslySetInnerHTML={{ __html:item.slider_title }} />
                                                            <p dangerouslySetInnerHTML={{ __html:item.slider_desc }} />
                                                        </li>
                                                    ))) : ( <p>No data found.</p> )}
                                            </ul>
                                            <ul className={
                                                    slide.button_title === groMarketPlace?.data?.slidername
                                                    ? "list-unstyled abt-ico-list"
                                                    : "d-none"
                                                }>
                                                    {slide.button_title === groMarketPlace?.data?.slidername ? (
                                                    groMarketPlace?.data?.slider_images?.map((item:any, index:number) => (
                                                        <li key={index}>
                                                            <img src={`${imagePath}${item.slider_img_url}`} />
                                                            <h6 dangerouslySetInnerHTML={{ __html:item.slider_title }} />
                                                            <p dangerouslySetInnerHTML={{ __html:item.slider_desc }} />
                                                        </li>
                                                    ))) : ( <p>No data found.</p> )}
                                            </ul>
                                             <ul className={
                                                    slide.button_title === groChartbot?.data?.slidername
                                                    ? "list-unstyled abt-ico-list"
                                                    : "d-none"
                                                }>
                                                    {slide.button_title === groChartbot?.data?.slidername ? (
                                                    groChartbot?.data?.slider_images?.map((item:any, index:number) => (
                                                        <li key={index}>
                                                            <img src={`${imagePath}${item.slider_img_url}`} />
                                                            <h6 dangerouslySetInnerHTML={{ __html:item.slider_title }} />
                                                            <p dangerouslySetInnerHTML={{ __html:item.slider_desc }} />
                                                        </li>
                                                    ))) : ( <p>No data found.</p> )}
                                            </ul>
                                        </div>

                                    </div>
                                </div>
                                <div className="col-md-5 d-flex align-items-center aos-init aos-animate" data-aos="zoom-out" data-aos-delay="100">
                                    <div className="row gy-4 ">
                                        <div className="col-sm-12 text-center">
                                            <img src={`${imagePath}${slide.slider_img_url}`} className="img-fluid px-lg-5 mb-5" />
                                            {/*  <button type="button" className="btn btn-success">DOWNLOAD NOW</button>*/}
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                    </section>
                </div>
                   ))}
            </div>
            <button className="carousel-control-prev" type="button" onClick={prevSlide} data-bs-target="#carouselaboutapp" data-bs-slide="prev">
                <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                <span className="visually-hidden">Previous</span>
            </button>
            <button className="carousel-control-next" type="button" onClick={nextSlide}  data-bs-target="#carouselaboutapp" data-bs-slide="next">
                <span className="carousel-control-next-icon" aria-hidden="true"></span>
                <span className="visually-hidden">Next</span>
            </button>

        </div>
        <div className="carouselaboutappMobile">
            <ul className="nav justify-content-center slide-nav ">
                 {groMainMSlider?.data?.slider_images?.map((slide:any, idx:number) => (
                    <li className="nav-item" key={idx}>
                        <button type="button" data-bs-toggle="tab" data-bs-target={`#tab-groslider${idx +1 }`}  onClick={() => setCurrentIndex(idx)}  data-bs-slide-to={`${idx +1 }`}  className={`nav-link ${idx === currentIndex ? 'active' : ''}`} aria-current="page" aria-label={`Slide ${idx +1 }`}>{slide.button_title}</button>
                    </li>
                 ))}
            </ul>
            <div className="tab-content">
                 {groMainMSlider?.data?.slider_images?.map((slide:any, idx:number) => (
                <div className={`tab-pane fade ${idx === currentIndex ? 'active show' : ''}`} id={`tab-groslider${idx +1 }`} role="tabpanel" aria-labelledby="nav-home-tab">
                    <section id={ slide.button_title === grokavachSlider?.data?.slidername  ? "aboutGrokavach": ""} 
                        className={slide.button_title === grokavachSlider?.data?.slidername  ? "about section mt-0 bg-grey-gradient": "d-none"} >
                            

                        <div className="container ">
                            <div className="row gx-2 align-items-xl-start gy-5  ">

                                <div className="col-xl-12 content mt-5   aos-init aos-animate" data-aos="fade-up" data-aos-delay="100">
                                    <div className="row gx-2">
                                        <div className="col-sm-12">
                                            <div className="abtgroOneApp">
                                                <img src={`${imagePath}${slide.slider_img_url}`} className="img-fluid px-xl-5 mb-5 float-start" />
                                                <div>
                                                    <h2>{slide.button_title}</h2>
                                                    <h6 className="py-1 fw-light" dangerouslySetInnerHTML={{ __html:slide.slider_title }} />
                                                    {/* <p className="py-3" dangerouslySetInnerHTML={{ __html:slide.slider_desc }} /> */}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row gx-2">
                                        <div className="col-sm-12">
                                            <div id="carouselgrokavach" className= {
                                                    slide.button_title === grokavachSlider?.data?.slidername
                                                    ? "carousel carousel-dark slide pointer-event"
                                                    : "d-none"
                                                }>
                                                <div className="carousel-indicators">
                                                     {grokavachSlider?.data?.slider_images?.map((item:any, index:number) => (
                                                    <button type="button" key={index} data-bs-target="#carouselgrokavach" data-bs-slide-to={`${index + 1}`} className={` ${index === currentIndexsub ? 'active' : ''}`} aria-current="true" aria-label="Slide 1"> </button>
                                                     ))}
                                                </div>
                                                <div className="carousel-inner  abt-ico-list-mobile">
                                                     {grokavachSlider?.data?.slider_images?.map((slide:any, index:number) => (
                                                    <div className={`carousel-item ${index === currentIndexsub ? 'active' : ''}`} key={index} data-bs-interval={`${index + 1}000`}>
                                                        <div className="carouselItemaboutApp">
                                                            <img src={`${imagePath}${slide.slider_img_url}`} />
                                                            <h6 dangerouslySetInnerHTML={{ __html:slide.slider_title }} />
                                                            <p dangerouslySetInnerHTML={{ __html:slide.slider_desc }} />
                                                        </div>
                                                    </div>
                                                     ))}

                                                </div>

                                                <button className="carousel-control-prev" onClick={prevSlide1} type="button" data-bs-target="#carouselgrokavach" data-bs-slide="prev">
                                                    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                                                    <span className="visually-hidden">Previous</span>
                                                </button>
                                                <button className="carousel-control-next"  onClick={nextSlide1} type="button" data-bs-target="#carouselgrokavach" data-bs-slide="next">
                                                    <span className="carousel-control-next-icon" aria-hidden="true"></span>
                                                    <span className="visually-hidden">Next</span>
                                                </button>
                                            </div>
                                          
                                        </div>

                                    </div>
                                </div>

                            </div>
                        </div>

                    </section>
                     <section id={ slide.button_title === groFASTagSlider?.data?.slidername ? "aboutFasttag": ""} 
                       className={slide.button_title === groFASTagSlider?.data?.slidername  ? "about section mt-0 bg-grey-gradient": "d-none"}>
                            

                        <div className="container ">
                            <div className="row gx-2 align-items-xl-start gy-5  ">

                                <div className="col-xl-12 content mt-5   aos-init aos-animate" data-aos="fade-up" data-aos-delay="100">
                                    <div className="row gx-2">
                                        <div className="col-sm-12">
                                            <div className="abtgroOneApp">
                                                <img src={`${imagePath}${slide.slider_img_url}`} className="img-fluid px-xl-5 mb-5 float-start" />
                                                <div>
                                                    <h2>{slide.button_title}</h2>
                                                    <h6 className="py-1 fw-light" dangerouslySetInnerHTML={{ __html:slide.slider_title }} />
                                                    {/* <p className="py-3" dangerouslySetInnerHTML={{ __html:slide.slider_desc }} /> */}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row gx-2">
                                        <div className="col-sm-12">
                                           
                                            <div id="carouselgrofasttag" className= {
                                                    slide.button_title === groFASTagSlider?.data?.slidername
                                                    ? "carousel carousel-dark slide pointer-event"
                                                    : "d-none"
                                                }>
                                                <div className="carousel-indicators">
                                                     {groFASTagSlider?.data?.slider_images?.map((item:any, index:number) => (
                                                    <button type="button" key={index} data-bs-target="#carouselgrofasttag" data-bs-slide-to={`${index + 1}`} className={` ${index === currentIndexsub ? 'active' : ''}`} aria-current="true" aria-label="Slide 1"> </button>
                                                     ))}
                                                </div>
                                                <div className="carousel-inner  abt-ico-list-mobile">
                                                     {groFASTagSlider?.data?.slider_images?.map((item:any, index:number) => (
                                                    <div className={`carousel-item ${index === currentIndexsub ? 'active' : ''}`} key={index} data-bs-interval={`${index + 1}000`}>
                                                        <div className="carouselItemaboutApp">
                                                            <img src={`${imagePath}${item.slider_img_url}`} />
                                                            <h6 dangerouslySetInnerHTML={{ __html:item.slider_title }} />
                                                            <p dangerouslySetInnerHTML={{ __html:item.slider_desc }} />
                                                        </div>
                                                    </div>
                                                     ))}

                                                </div>

                                                <button className="carousel-control-prev" onClick={prevSlide2} type="button" data-bs-target="#carouselgrokavach" data-bs-slide="prev">
                                                    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                                                    <span className="visually-hidden">Previous</span>
                                                </button>
                                                <button className="carousel-control-next"  onClick={nextSlide2} type="button" data-bs-target="#carouselgrokavach" data-bs-slide="next">
                                                    <span className="carousel-control-next-icon" aria-hidden="true"></span>
                                                    <span className="visually-hidden">Next</span>
                                                </button>
                                            </div>
                                           


                                        </div>

                                    </div>
                                </div>

                            </div>
                        </div>

                    </section>
                     <section id={ slide.button_title === groDhanSlider?.data?.slidername ? "aboutGroenDhan": ""} 
                       className={slide.button_title === groDhanSlider?.data?.slidername  ? "about section mt-0 bg-grey-gradient": "d-none"}>
                       
                            

                        <div className="container ">
                            <div className="row gx-2 align-items-xl-start gy-5  ">

                                <div className="col-xl-12 content mt-5   aos-init aos-animate" data-aos="fade-up" data-aos-delay="100">
                                    <div className="row gx-2">
                                        <div className="col-sm-12">
                                            <div className="abtgroOneApp">
                                                <img src={`${imagePath}${slide.slider_img_url}`} className="img-fluid px-xl-5 mb-5 float-start" />
                                                <div>
                                                    <h2>{slide.button_title}</h2>
                                                    <h6 className="py-1 fw-light" dangerouslySetInnerHTML={{ __html:slide.slider_title }} />
                                                    {/* <p className="py-3" dangerouslySetInnerHTML={{ __html:slide.slider_desc }} /> */}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row gx-2">
                                        <div className="col-sm-12">
                                           
                                             <div id="carouselgroendhan" className= {
                                                    slide.button_title === groDhanSlider?.data?.slidername
                                                    ? "carousel carousel-dark slide pointer-event"
                                                    : "d-none"
                                                }>
                                                <div className="carousel-indicators">
                                                     {groDhanSlider?.data?.slider_images?.map((item:any, index:number) => (
                                                    <button type="button" key={index} data-bs-target="#carouselgrofasttag" data-bs-slide-to={`${index + 1}`} className={` ${index === currentIndexsub ? 'active' : ''}`} aria-current="true" aria-label="Slide 1"> </button>
                                                     ))}
                                                </div>
                                                <div className="carousel-inner  abt-ico-list-mobile">
                                                     {groDhanSlider?.data?.slider_images?.map((item:any, index:number) => (
                                                    <div className={`carousel-item ${index === currentIndexsub ? 'active' : ''}`} key={index} data-bs-interval={`${index + 1}000`}>
                                                        <div className="carouselItemaboutApp">
                                                            <img src={`${imagePath}${item.slider_img_url}`} />
                                                            <h6 dangerouslySetInnerHTML={{ __html:item.slider_title }} />
                                                            <p dangerouslySetInnerHTML={{ __html:item.slider_desc }} />
                                                        </div>
                                                    </div>
                                                     ))}

                                                </div>

                                                <button className="carousel-control-prev" onClick={prevSlide3} type="button" data-bs-target="#carouselgrokavach" data-bs-slide="prev">
                                                    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                                                    <span className="visually-hidden">Previous</span>
                                                </button>
                                                <button className="carousel-control-next"  onClick={nextSlide3} type="button" data-bs-target="#carouselgrokavach" data-bs-slide="next">
                                                    <span className="carousel-control-next-icon" aria-hidden="true"></span>
                                                    <span className="visually-hidden">Next</span>
                                                </button>
                                            </div>
                                            


                                        </div>

                                    </div>
                                </div>

                            </div>
                        </div>

                    </section>
                     <section id={ slide.button_title === groFleetSlider?.data?.slidername ? "aboutFleetGps": ""} 
                         className={slide.button_title === groFleetSlider?.data?.slidername  ? "about section mt-0 bg-grey-gradient": "d-none"}>
                       
                            

                        <div className="container ">
                            <div className="row gx-2 align-items-xl-start gy-5  ">

                                <div className="col-xl-12 content mt-5   aos-init aos-animate" data-aos="fade-up" data-aos-delay="100">
                                    <div className="row gx-2">
                                        <div className="col-sm-12">
                                            <div className="abtgroOneApp">
                                                <img src={`${imagePath}${slide.slider_img_url}`} className="img-fluid px-xl-5 mb-5 float-start" />
                                                <div>
                                                    <h2>{slide.button_title}</h2>
                                                    <h6 className="py-1 fw-light" dangerouslySetInnerHTML={{ __html:slide.slider_title }} />
                                                    {/* <p className="py-3" dangerouslySetInnerHTML={{ __html:slide.slider_desc }} /> */}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row gx-2">
                                        <div className="col-sm-12">
                                      
                                             <div id="carouselgrofleetgps" className= {
                                                    slide.button_title === groFleetSlider?.data?.slidername
                                                    ? "carousel carousel-dark slide pointer-event"
                                                    : "d-none"
                                                }>
                                                <div className="carousel-indicators">
                                                     {groFleetSlider?.data?.slider_images?.map((item:any, index:number) => (
                                                    <button type="button" key={index} data-bs-target="#carouselgrofleetgps" data-bs-slide-to={`${index + 1}`} className={` ${index === currentIndexsub ? 'active' : ''}`} aria-current="true" aria-label="Slide 1"> </button>
                                                     ))}
                                                </div>
                                                <div className="carousel-inner  abt-ico-list-mobile">
                                                     {groFleetSlider?.data?.slider_images?.map((item:any, index:number) => (
                                                    <div className={`carousel-item ${index === currentIndexsub ? 'active' : ''}`} key={index} data-bs-interval={`${index + 1}000`}>
                                                        <div className="carouselItemaboutApp">
                                                            <img src={`${imagePath}${item.slider_img_url}`} />
                                                            <h6 dangerouslySetInnerHTML={{ __html:item.slider_title }} />
                                                            <p dangerouslySetInnerHTML={{ __html:item.slider_desc }} />
                                                        </div>
                                                    </div>
                                                     ))}

                                                </div>

                                                <button className="carousel-control-prev" onClick={prevSlide4} type="button" data-bs-target="#carouselgrokavach" data-bs-slide="prev">
                                                    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                                                    <span className="visually-hidden">Previous</span>
                                                </button>
                                                <button className="carousel-control-next"  onClick={nextSlide4} type="button" data-bs-target="#carouselgrokavach" data-bs-slide="next">
                                                    <span className="carousel-control-next-icon" aria-hidden="true"></span>
                                                    <span className="visually-hidden">Next</span>
                                                </button>
                                            </div>


                                        </div>

                                    </div>
                                </div>

                            </div>
                        </div>

                    </section>
                    <section id={ slide.button_title === groMarketPlace?.data?.slidername ? "aboutFleetGps": ""} 
                         className={slide.button_title === groMarketPlace?.data?.slidername  ? "about section mt-0 bg-grey-gradient": "d-none"}>
                       
                        <div className="container ">
                            <div className="row gx-2 align-items-xl-start gy-5  ">

                                <div className="col-xl-12 content mt-5   aos-init aos-animate" data-aos="fade-up" data-aos-delay="100">
                                    <div className="row gx-2">
                                        <div className="col-sm-12">
                                            <div className="abtgroOneApp">
                                                <img src={`${imagePath}${slide.slider_img_url}`} className="img-fluid px-xl-5 mb-5 float-start" />
                                                <div>
                                                    <h2>{slide.button_title}</h2>
                                                    <h6 className="py-1 fw-light" dangerouslySetInnerHTML={{ __html:slide.slider_title }} />
                                                    {/* <p className="py-3" dangerouslySetInnerHTML={{ __html:slide.slider_desc }} /> */}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row gx-2">
                                        <div className="col-sm-12">
                                      
                                             <div id="carouselgrofleetgps" className= {
                                                    slide.button_title === groMarketPlace?.data?.slidername
                                                    ? "carousel carousel-dark slide pointer-event"
                                                    : "d-none"
                                                }>
                                                <div className="carousel-indicators">
                                                     {groMarketPlace?.data?.slider_images?.map((item:any, index:number) => (
                                                    <button type="button" key={index} data-bs-target="#carouselgrofleetgps" data-bs-slide-to={`${index + 1}`} className={` ${index === currentIndexsub ? 'active' : ''}`} aria-current="true" aria-label="Slide 1"> </button>
                                                     ))}
                                                </div>
                                                <div className="carousel-inner  abt-ico-list-mobile">
                                                     {groMarketPlace?.data?.slider_images?.map((item:any, index:number) => (
                                                    <div className={`carousel-item ${index === currentIndexsub ? 'active' : ''}`} key={index} data-bs-interval={`${index + 1}000`}>
                                                        <div className="carouselItemaboutApp">
                                                            <img src={`${imagePath}${item.slider_img_url}`} />
                                                            <h6 dangerouslySetInnerHTML={{ __html:item.slider_title }} />
                                                            <p dangerouslySetInnerHTML={{ __html:item.slider_desc }} />
                                                        </div>
                                                    </div>
                                                     ))}

                                                </div>

                                                <button className="carousel-control-prev" onClick={prevSlide5} type="button" data-bs-target="#carouselgrokavach" data-bs-slide="prev">
                                                    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                                                    <span className="visually-hidden">Previous</span>
                                                </button>
                                                <button className="carousel-control-next"  onClick={nextSlide5} type="button" data-bs-target="#carouselgrokavach" data-bs-slide="next">
                                                    <span className="carousel-control-next-icon" aria-hidden="true"></span>
                                                    <span className="visually-hidden">Next</span>
                                                </button>
                                            </div>


                                        </div>

                                    </div>
                                </div>

                            </div>
                        </div>

                    </section>
                    <section id={ slide.button_title === groChartbot?.data?.slidername ? "aboutFleetGps": ""} 
                         className={slide.button_title === groChartbot?.data?.slidername  ? "about section mt-0 bg-grey-gradient": "d-none"}>
                       
                        <div className="container ">
                            <div className="row gx-2 align-items-xl-start gy-5  ">

                                <div className="col-xl-12 content mt-5   aos-init aos-animate" data-aos="fade-up" data-aos-delay="100">
                                    <div className="row gx-2">
                                        <div className="col-sm-12">
                                            <div className="abtgroOneApp">
                                                <img src={`${imagePath}${slide.slider_img_url}`} className="img-fluid px-xl-5 mb-5 float-start" />
                                                <div>
                                                    <h2>{slide.button_title}</h2>
                                                    <h6 className="py-1 fw-light" dangerouslySetInnerHTML={{ __html:slide.slider_title }} />
                                                    {/* <p className="py-3" dangerouslySetInnerHTML={{ __html:slide.slider_desc }} /> */}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row gx-2">
                                        <div className="col-sm-12">
                                      
                                             <div id="carouselgrofleetgps" className= {
                                                    slide.button_title === groChartbot?.data?.slidername
                                                    ? "carousel carousel-dark slide pointer-event"
                                                    : "d-none"
                                                }>
                                                <div className="carousel-indicators">
                                                     {groChartbot?.data?.slider_images?.map((item:any, index:number) => (
                                                    <button type="button" key={index} data-bs-target="#carouselgrofleetgps" data-bs-slide-to={`${index + 1}`} className={` ${index === currentIndexsub ? 'active' : ''}`} aria-current="true" aria-label="Slide 1"> </button>
                                                     ))}
                                                </div>
                                                <div className="carousel-inner  abt-ico-list-mobile">
                                                     {groChartbot?.data?.slider_images?.map((item:any, index:number) => (
                                                    <div className={`carousel-item ${index === currentIndexsub ? 'active' : ''}`} key={index} data-bs-interval={`${index + 1}000`}>
                                                        <div className="carouselItemaboutApp">
                                                            <img src={`${imagePath}${item.slider_img_url}`} />
                                                            <h6 dangerouslySetInnerHTML={{ __html:item.slider_title }} />
                                                            <p dangerouslySetInnerHTML={{ __html:item.slider_desc }} />
                                                        </div>
                                                    </div>
                                                     ))}

                                                </div>

                                                <button className="carousel-control-prev" onClick={prevSlide6} type="button" data-bs-target="#carouselgrokavach" data-bs-slide="prev">
                                                    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                                                    <span className="visually-hidden">Previous</span>
                                                </button>
                                                <button className="carousel-control-next"  onClick={nextSlide6} type="button" data-bs-target="#carouselgrokavach" data-bs-slide="next">
                                                    <span className="carousel-control-next-icon" aria-hidden="true"></span>
                                                    <span className="visually-hidden">Next</span>
                                                </button>
                                            </div>


                                        </div>

                                    </div>
                                </div>

                            </div>
                        </div>

                    </section>
                </div>
              ))}
            </div>
        </div>
        </LazySection>
       {/* Download Section - Lazy loaded */}
        {data.stats && (
          <>
            {/* <Suspense fallback={<div className="lazy-loading">Loading download section...</div>}>
              <GroOneDownload 
                urls={processedUrls}
                appImages={data.stats.images}
              />
            </Suspense> */}
             <section className="section dowload pt-2">
                <div className="container">
                    <div className="row align-content-center">
                    <div className="offset-sm-1 col-sm-10 border-top text-center pt-4 justify-content-center">
                        <div className="d-inline align-content-xxl-around">
                        <h5 className="d-inline pe-lg-3">
                            <b>{grooneappcontent || " "}</b>
                        </h5>
                        <div className="d-flex mt-3 justify-content-center">
                            <a href={appurl || ""} title={appurl || ""}>
                            <img src={appimg || ""} className="img-fluid" alt="App Store" loading="lazy" decoding="async" />
                            </a>
                            <a href={googleurl || ""} className="grooneappimg" title={googleurl || ""}>
                            <img src={googleimg || ""} className="img-fluid" alt="Google Play" loading="lazy" decoding="async" />
                            </a>
                        </div>
                        </div>
                    </div>
                    </div>
                </div>
                </section>
          </>
        )}

        {/* Testimonials Section */}
        {/* <TestimonalSliderClient /> */}

        {/* FAQ Section - Lazy loaded */}
        {data.faq && (
          <LazySection>
            <Suspense fallback={<div className="lazy-loading">Loading FAQ...</div>}>
              <GroOneFAQ faqData={data.faq} />
            </Suspense>
          </LazySection>
        )}

    </main>

   </>
  );
};

export default Grooneapp;